
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore",
      function () {
        return require("private-next-pages/explore.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore"])
      });
    }
  